import { useQuery } from '@apollo/client';

import { getFeatureFlag } from '@/api';
import { resolveGqlErrors } from '@/helpers';

interface UseFeatureFlag {
  loading: boolean;
  enabled: boolean;
  error: string;
}

export const useFeatureFlag = (flag: string): UseFeatureFlag => {
  const { loading, data, error } = useQuery(getFeatureFlag, {
    variables: { flag },
    fetchPolicy: 'cache-first',
  });

  return {
    loading,
    enabled: data?.getFeatureFlag?.featureFlag?.enabled || false,
    error: resolveGqlErrors(error || data?.getFeatureFlag?.error),
  };
};
